import { useContext } from 'react';
import { CliConfigContext } from '../providers/CliConfigProvider';
function useCliCustomerConfigContext() {
    return useContext(CliConfigContext);
}
export default useCliCustomerConfigContext;
